/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Name of the feature to update
 */
export const FeatureName = {
  Logs: "logs",
  ToolIoLogs: "tool_io_logs",
  SessionCapture: "session_capture",
  AuthzChallengeLogging: "authz_challenge_logging",
  Sso: "sso",
  Scim: "scim",
  HooksBrowserLogin: "hooks_browser_login",
  HooksFailOpen: "hooks_fail_open",
  CustomModelKeys: "custom_model_keys",
  Skills: "skills",
  SkillCaptureMetadataOnly: "skill_capture_metadata_only",
  AiPlatformPushIntegrations: "ai_platform_push_integrations",
  PlatformMcp: "platform_mcp",
  CustomerManagedEncryptionKeys: "customer_managed_encryption_keys",
  RemoteSessionAutoRefresh: "remote_session_auto_refresh",
  RemoteSessionAutoRefreshEnforced: "remote_session_auto_refresh_enforced",
  SessionPortability: "session_portability",
  NetworkIngress: "network_ingress",
  SignalsIntelligence: "signals_intelligence",
  OrganizationGatewayDisabled: "organization_gateway_disabled",
  CodeMode: "code_mode",
} as const;
/**
 * Name of the feature to update
 */
export type FeatureName = ClosedEnum<typeof FeatureName>;

export type SetProductFeatureRequestBody = {
  /**
   * Whether the feature should be enabled
   */
  enabled: boolean;
  /**
   * Name of the feature to update
   */
  featureName: FeatureName;
  /**
   * Organization whose product feature to update.
   */
  organizationId: string;
};

/** @internal */
export const FeatureName$outboundSchema: z.ZodMiniEnum<typeof FeatureName> = z
  .enum(FeatureName);

/** @internal */
export type SetProductFeatureRequestBody$Outbound = {
  enabled: boolean;
  feature_name: string;
  organization_id: string;
};

/** @internal */
export const SetProductFeatureRequestBody$outboundSchema: z.ZodMiniType<
  SetProductFeatureRequestBody$Outbound,
  SetProductFeatureRequestBody
> = z.pipe(
  z.object({
    enabled: z.boolean(),
    featureName: FeatureName$outboundSchema,
    organizationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      featureName: "feature_name",
      organizationId: "organization_id",
    });
  }),
);

export function setProductFeatureRequestBodyToJSON(
  setProductFeatureRequestBody: SetProductFeatureRequestBody,
): string {
  return JSON.stringify(
    SetProductFeatureRequestBody$outboundSchema.parse(
      setProductFeatureRequestBody,
    ),
  );
}
